module.exports = __webpack_public_path__ + "img/lesson3_dialog1.27e823ec.svg";